<template>
  <textarea
      class="
        border
        rounded-3xl
        w-full
        selected:border-blue-800
        disabled:opacity-50
        disabled:border-gray-800
        disabled:bg-gray-300
        form-textarea
      "
      :value="modelValue" @input="$emit('update:modelValue', $event.target.value)"
    :class="stateClasses"
  />
</template>

<script>

export default {
    props: ['modelValue'],
    emits: ['update:modelValue'],
    methods: {
        focus() {
            this.$refs.input.focus()
        }
    },
    computed:{
        stateClasses(){
        if(this.state == 'success'){
            return 'border-green-500'
        }
        if(this.state == 'error'){
            return 'border-red-500'
        }
        return 'border-gray-500'
        }
    }
};
</script>
